import React, { useEffect, useState } from "react";
import axios from "axios";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import { useParams } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function FaqSection() {
  const { section, id } = useParams();
  const [activeIndex, setActiveIndex] = useState(null);
const [faqData, setFaqData] = useState([]);
  const toggleFAQ = (index) => {
    setActiveIndex(prev => (prev === index ? null : index));
  };

  useEffect(() => {
          (async () => await fetchSpeechesData())();
        }, [section, id]);
      
        async function fetchSpeechesData() {
          try {
            await axios.get("sanctum/csrf-cookie");
      
            const responses = await Promise.all([
              axios.get(
                `${BASE_URL}faqdata?visibility[eq]=publish`
              ),
            ]);
      
            const [posdata] = responses;
            if (posdata.data.status === 200) {
              if (posdata.data.allData.length > 0) {
                setFaqData(posdata.data.allData);
                
              }else{
                setFaqData([]);
              }
            } else {
              
              console.log("Oops!", posdata.data.validation_error);
            }
          } catch (error) {
            console.log("Error", "There were no Data found!");
          }
        }

        if (faqData.length === 0) {
          return null; // Nothing renders if there's no data
        }

  return (
    <section id="faq" className="faq section light-background">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>F.A.Q</h2>
        <p>
          <span>Frequently Asked</span>{' '}
          <span className="description-title">Questions</span>
        </p>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10" data-aos="fade-up" data-aos-delay={100}>
            <div className="faq-container">
              {faqData.map((item, index) => (
                <div
                  className={`faq-item ${activeIndex === index ? 'faq-active' : ''}`}
                  key={index}
                  onClick={() => toggleFAQ(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <h3>{item.faq}</h3>
                  <div
                    className="faq-content text-secondary"
                    style={{
                      maxHeight: activeIndex === index ? '200px' : '0',
                      overflow: 'hidden',
                      transition: 'max-height 0.3s ease',
                    }}
                  >
                    {/* <p style="text-align:justify"><span style="font-size:14px">Visit the homepage and search for your desired property using the available search filters. Alternatively, applicants can search using the map provided.</span></p> */}
                    <h4 style={{ marginTop: activeIndex === index ? '10px' : '0', color:"white" }}>
                    <HTMLDisplay html={item.faqAns} textNo={100} type="title"/>
                    </h4>
                  </div>
                  <i
                    className={`faq-toggle bi ${
                      activeIndex === index ? 'bi-chevron-down' : 'bi-chevron-right'
                    }`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
